// Original concept by Tom Bogner @dastom on Dribble: https://dribbble.com/shots/6767548-The-Three-Graces-Concept

import React from 'react'
import { useRef, useEffect } from 'react'
import { Canvas, extend, useFrame } from '@react-three/fiber'
import { useGLTF, useAnimations, SoftShadows } from '@react-three/drei'
import { easing, geometry } from 'maath'
import { EffectComposer, Bloom } from '@react-three/postprocessing'

extend(geometry)

export default function App() {
  return (
    <Canvas shadows="basic" eventSource={document.getElementById('root')} eventPrefix="client" camera={{ position: [0, 1.5, 14], fov: 45 }}>
      <pointLight position={[-10, -10, -10]} intensity={0.005} color={[51, 102, 255]} />
      <pointLight position={[-10, 10, -10]} intensity={0.0008} color={[102, 204, 153]} />
      <pointLight position={[10, -10, 5]} intensity={0.0008} color={[204, 51, 204]} />

      <pointLight position={[10, -10, -20]} intensity={4} />
      <ambientLight intensity={0.1} />
      <Model />
      <EffectComposer disableNormalPass>
        <Bloom luminanceThreshold={0.3} mipmapBlur />
      </EffectComposer>
      <SoftShadows samples={3} />
    </Canvas>
  )
}

function Model(props) {
  const group = useRef()
  const light = useRef()
  const { nodes, animations } = useGLTF("./lionScene.glb")
  const { actions } = useAnimations(animations, group)

  useFrame((state, delta) => {
    easing.dampE(group.current.rotation, [0, -state.pointer.x * (Math.PI / 10), 0], 1.5, delta)
    easing.damp3(group.current.position, [0, -5.5, 1 - Math.abs(state.pointer.x)], 1, delta)
    easing.damp3(light.current.position, [state.pointer.x * 30, 1, 15 + state.pointer.y * 4], 0.1, delta)
  })

  useEffect(() => {
    actions['LION'].play()
  })

  return (
    <group ref={group} {...props}>
      <primitive object={nodes.node85} position={[0, 5.5, 0]} scale={[3, 3, 3]} />
      <spotLight angle={0.4} penumbra={0.4} ref={light} castShadow intensity={6} color="Purple" shadow-mapSize={1024} shadow-bias={-0.001}>
        <orthographicCamera attach="shadow-camera" args={[-20, 20, -20, 20, 0.5, 100]} />
      </spotLight>
    </group>
  )
}
